// eslint-disable-next-line no-return-assign
export const lockScroll = () => (document.body.style.overflow = 'hidden')

// eslint-disable-next-line no-return-assign
export const unlockScroll = () => (document.body.style.overflow = 'unset')
